<template>
  <VuetifyPhoneInput
    :initial="internal"
    :label="label"
    :preferred-countries="['FR', 'BE', 'DE', 'US', 'GB']"
    :ignored-countries="[]"
    @update:phone="updatePhone($event)"
    :density="density"
    autocomplete="off"
    hide-details="auto"
  />
</template>
<script>
import VuetifyPhoneInput from 'src/components/UIComponents/Inputs/VuetifyPhoneInput.vue';

export default {
  components: {
    VuetifyPhoneInput,
  },
  name: 'phone-number',
  data() {
    return {
      phone: undefined,
      internal: undefined,
      valid: false,
    };
  },
  props: {
    initial: String,
    orientation: {
      type: String,
      default: 'row',
      deprecated: true,
    },
    label: {
      type: String,
      default: 'Phone Number',
    },
    size: {
      type: String,
      default: 'sm',
    },
    density: {
      type: String,
      default: 'compact',
    },
    block: {
      type: Boolean,
      default: false,
      deprecated: true,
    },
  },
  computed: {},
  created() {
    this.internal = this.initial;
  },
  watch: {
    initial(n) {
      this.internal = n;
    },
  },
  methods: {
    updatePhone(result) {
      // Assume empty is valid when removing a number
      if (this.initial && result?.phoneNumber == undefined) {
        this.valid = true;
        // Allow unsetting on empty as undefined will be skipped
        this.$emit('update:phone', null);
        return;
      }

      if (result?.valid == this.valid) {
        // only emit events on state change
        return;
      }
      if (result && result.valid) {
        this.phone = result.e164;
        this.valid = true;
        this.$emit('update:phone', result.e164);
        return;
      }
      this.valid = false;
    },
  },
};
</script>
<!-- lang="postcss" -->
<style>
/* .input-tel__label {
  top: -10px !important;
}
.country-selector__label {
  top: -10px !important;
}
.country-selector__toggle {
  top: calc(50% - 20px) !important;
} */

/* These override the CSS styles for all of the maz ui phone numbner */
.m-phone-number-input.--row
  .m-country-selector__select
  .m-select-input
  .m-input-wrapper {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}
.m-phone-number-input.--row .m-phone-input.--border-radius .m-input-wrapper {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}
</style>
